import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { PreLoginService } from 'src/app/pre-login/pre-login.service';
import { IOpenPurchaseOrder, IOpenPurchaseOrderPayload } from '../model/purchase-order.model';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  constructor(private _httpProviders: HttpProviderService,
    private _preLoginService: PreLoginService) {}

  openPurchaseOrder(payload: IOpenPurchaseOrderPayload) {
    const httpRequestPayload: HttpRequestPayload = {
      method: "POST",
      resource: "/mfpurchaseorder",
      body: payload,
    };
    return this._httpProviders.invokeApi(httpRequestPayload).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          const mfpurchaseorderResponse = {
            httpStatus : response.status,
            inventoryNo : response.body.mfpurchaseorder.inventoryNumber,
            refNo: response.body.mfpurchaseorder.refNo,
          }
          if (response.status == 201) {
            this._preLoginService.setUserTwoFactor({ email: response.body.mfpurchaseorder.twoFactor?.email, mobile: response.body.mfpurchaseorder.twoFactor?.mobile });
          }
          return mfpurchaseorderResponse
        },
        catchError((err: IHttpErrorPayload) => {
          return of(err);
        })
      )
    );
  }
  fetchPurchaseDetails(requestReference:any): Observable<any> {
    const request: HttpRequestPayload = {
      resource: `/mfpurchaseorder/${requestReference}`,
      method: 'GET',
    };
    return this._httpProviders.invokeApi(request).pipe(
      map(
        (response: IHttpSuccessPayload<any>) => {
          const mfpurchaseorderResponse = {
            httpStatus : response.status,
            refNo: response.body.mfpurchaseorder.refNo,
          }
          return mfpurchaseorderResponse
        },
        catchError((err: IHttpErrorPayload) => {
          return of(err);
        })
      )
    );
  }
  fetchPurchaseOrderDetails(requestReference): Observable<IOpenPurchaseOrder> {
    const httpRequest : HttpRequestPayload = {
      resource : `/mfpurchaseorder/${requestReference}`,
      method : "GET"
    }
    return this._httpProviders.invokeApi(httpRequest).pipe(map((response : IHttpSuccessPayload<any>) => {
      const requestPurhcaseOrderResponse : IOpenPurchaseOrder = response.body.mfpurchaseorder
      return requestPurhcaseOrderResponse
    },
    catchError((err : IHttpErrorPayload) => { 
      return throwError(err)
    })));
  }
}
